<template>
  <entity-list v-if="$route.params.id === undefined"
               :form-config="formConfig"
  />
  <entity-edit v-else-if="$route.params.id !== undefined"
               :entity-id="$route.params.id"
               :form-config="formConfig"
  />
</template>
<script>
import {FormConfig, PropertyConfig, FieldType, Filter, Operator, Action} from '../../common/index.d.ts'
import EntityList from '../../common/EntityList'
import EntityEdit from '../../common/EntityEdit'

import {ref} from '@vue/composition-api'
import {useRouter} from '@core/utils/utils'
import store from '@/store'

export default {
  components: {
    EntityList,
    EntityEdit,
  },

  setup(props) {
    const router = useRouter().route;
    console.log(router)
    let entityId = undefined
    try {
      entityId = router.value.params.id
    } catch (e) {

    }
    let arr = [
      new PropertyConfig("id", "Id", FieldType.TEXT),
      new PropertyConfig("name", "Name", FieldType.TEXT),
      new PropertyConfig("image", "Image", FieldType.CK_IMAGE),
    ];
    let formConfig = new FormConfig(undefined, arr, "album").withSearchName("name")
        .withActions([new Action("Edit", "apps-album"),
          new Action("Photos", "apps-album-photos").withRouterKey("album_id")]);
    return {
      entityId,
      formConfig,
    }
  },
}
</script>

